import {default as ReactDatePicker} from 'react-datepicker'
import InputGroup from 'react-bootstrap/InputGroup';
import {useCallback, useState} from 'react'
import th from 'date-fns/locale/th';
import {format, isValid, parse} from 'date-fns'

const DatepickerInput = ({
  selectsRange,
  inputGroupClassName,
  enableTyping,
  inputError,
  iconName,
  ...inputProps
}: any) => {
  const rawValue = inputProps.value || ''
  const split = rawValue.split(' - ')
  let value = rawValue

  if (split.length === 2) {
    if (split[0] === split[1]) {
      value = split[0]
    }
  }

  return <div>
    <InputGroup style={selectsRange?{minWidth: 255}:{}} className={inputGroupClassName||"mb-3"}>
      <input
        type="text"
        {...inputProps}
        value={value}
        readOnly={!enableTyping}
        aria-invalid={Boolean(inputError)}
        className={`${inputProps.className || ''} ${inputError ? 'is-invalid' : ''}`.trim()}
      />
      <InputGroup.Text id="basic-addon2"><i className={'bi bi-'+ (iconName||'calendar-event') +' fs-7'}></i></InputGroup.Text>
    </InputGroup>
    {inputError && <div className="invalid-feedback d-block mt-n2 mb-2">{inputError}</div>}
  </div>
};

export default function DatePicker(props: any) {
  const name = props.name
  const [inputError, setInputError] = useState('')
  const dateFormats = Array.isArray(props.dateFormat)
    ? props.dateFormat
    : [props.dateFormat || 'dd/MM/yyyy']

  const isValidDateText = useCallback((value: string) => {
    return dateFormats.some((dateFormat: string) => {
      try {
        const parsed = parse(value, dateFormat, new Date(), {locale: th})
        return isValid(parsed) && format(parsed, dateFormat, {locale: th}) === value
      } catch {
        return false
      }
    })
  }, [dateFormats.join('|')])

  const validateTypedValue = useCallback((value: string) => {
    if (!value) {
      setInputError('')
      return
    }

    const dateValues = props.selectsRange ? value.split(' - ') : [value]
    const isValidValue = dateValues.every((dateValue: string) => isValidDateText(dateValue))
    setInputError(isValidValue ? '' : `กรุณากรอกวันที่ให้ถูกต้อง (${dateFormats.join(' หรือ ')})`)
  }, [dateFormats.join('|'), isValidDateText, props.selectsRange])

  const onChangeHandler = useCallback(
  (date: Date, e: React.SyntheticEvent<any>) => {
    if (date) setInputError('')
    props.onChange(date, e, name)
  },
  [props.onChange, name]
)

  const onChangeRawHandler = useCallback((event: React.SyntheticEvent<HTMLInputElement>) => {
    validateTypedValue(event.currentTarget.value)
    props.onChangeRaw?.(event)
  }, [props.onChangeRaw, validateTypedValue])

  return  (
    <ReactDatePicker
      {...props}
      className={"form-control"}
      onChange={onChangeHandler}
      onChangeRaw={onChangeRawHandler}
      strictParsing
      customInput={<DatepickerInput
          selectsRange={props.selectsRange}
         enableTyping={props.enableTyping ?? true}
         inputError={inputError}
         inputGroupClassName={props.inputGroupClassName}
         iconName={props.iconName} />}
      locale={th}
    />
  )
}
